import { render, staticRenderFns } from "./SearchSummary.vue?vue&type=template&id=189f7347&scoped=true"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"
import style0 from "./SearchSummary.vue?vue&type=style&index=0&id=189f7347&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f7347",
  null
  
)

export default component.exports